import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { ErrorResponse } from "../../../requests/@types";
import api from "../../../services/api";
import { ExtractedFilesResponse } from "../@types/extracted_files";

const EXTRACTED_FILES_KEY = "extractedFiles";

type ExtractedFilesQP = {
  page: number;
  page_size: number;
  view_type: "DIR" | "FLAT";
  path?: string;
  relationship?: number | string;
  ordering?: string;
};

const useGetExtractedFiles = (sha1: string, qp: ExtractedFilesQP) => {
  const { data, isLoading, refetch, error } = useQuery<
    AxiosResponse<ExtractedFilesResponse>,
    ErrorResponse,
    ExtractedFilesResponse
  >({
    queryKey: [EXTRACTED_FILES_KEY, sha1, qp],
    queryFn: ({ signal }) =>
      api.getExtractedFiles({ hashValue: sha1, extractedFilesQP: qp }, signal),
    select: ({ data: response }) => response
  });

  return { data, isLoading, error, refetch };
};

export default useGetExtractedFiles;
